<template>
    <ui-container class="py-8 space-y-8">
        <!-- Header. -->
        <ui-header :title="`Fine ${item.pcn_number} - ${item.formatted_date}`" :subtitle="` `">
            <template #actions>
                <ui-button-new icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
                <ui-button-new icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
            </template>
        </ui-header>
        <tab-list>
            <tab name="Overview" active="true">
                <ui-data-grid>
                    <ui-data-grid-item label="Fine ID" :value="'#'+item.id"></ui-data-grid-item>
                    <ui-data-grid-item label="Vehicle Registration" :value="item.vehicle_name"></ui-data-grid-item>
                    <ui-data-grid-item label="PCN Number" :value="'#'+item.pcn_number"></ui-data-grid-item>
                    <ui-data-grid-item label="Amount" :value="'£'+money(item.amount)"></ui-data-grid-item>
                    <ui-data-grid-item label="Driver" :value="item.driver_name"></ui-data-grid-item>
                    <ui-data-grid-item label="Fine Authority" :value="item.fine_auth"></ui-data-grid-item>
                    <ui-data-grid-item wide label="Package" :value="item.package_name"></ui-data-grid-item>
                    <ui-data-grid-item wide label="Offense" :value="item.offense"></ui-data-grid-item>
                    <ui-data-grid-item wide label="Status" :value="item.status"></ui-data-grid-item>
                    <ui-data-grid-item label="Created By">{{ item.created_by }} on {{
                            item.created_at
                        }}
                    </ui-data-grid-item>
                    <ui-data-grid-item label="Last Updated By">{{ item.updated_by }} on {{
                            item.updated_at
                        }}
                    </ui-data-grid-item>
                </ui-data-grid>
            </tab>
            <tab name="Files">
                <fs :filesystemId="item.filesystem_id"></fs>
            </tab>
        </tab-list>

    </ui-container>
</template>

<script>
import AutoresizableTextarea from "../ui/AutoresizableTextarea";
import UiContainer from "../ui/UiContainer.vue";
import UiDropdownItem from "../ui/UiDropdownItem.vue";
import UiDropdown from "../ui/UiDropdown.vue";
import UiButtonNew from "../ui/UiButtonNew.vue";
import UiDataGrid from "../ui/UiDataGrid.vue";
import UiDataGridItem from "../ui/UiDataGridItem.vue";

export default {
    components: {
        UiDataGridItem,
        UiDataGrid,
        UiButtonNew, UiDropdown, UiDropdownItem, UiContainer, AutoresizableTextarea
    },
    props: {
        item: Object,
        edit: Function,
        removeItem: Function,
        addItem: Function,
    },
    computed: {},
    data() {
        return {}
    },
    methods: {
        money: function (val) {
            return parseFloat(val).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        openDeleteModal() {
            const title = 'Are you sure you want to remove Fine ' + this.item.pcn_number + '?'
            const description = 'You are removing Fine #' + this.item.id + '. Are you sure you want to do this?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

            });
        },
        resolve() {
        },
    },
}
</script>
